module.exports = __webpack_public_path__ + "static/img/main.302154af.png";